import { mapActions, mapState } from 'vuex';

import { PaymentTypeClient } from '../enums/paymentMagicNumberEnum';

export const updatePaymentMixin = {
  name: 'updatePaymentMixin',
  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
  },
  methods: {
    ...mapActions([
      'updateAdmissionPaymentHealthInsurance',
      'updateAdmissionPaymentPrivate',
      'updateAdmissionPaymentSwitchType',
      'setAdmissionNotElegible',
    ]),

    async updateAdmissionPaymentCommand_mixin(paymentPayload) {
      const updateToPrivate = paymentPayload.clientId === PaymentTypeClient.PRIVATE;
      const updateToHealthInsurance = !updateToPrivate;

      const isPrivate = this.currentAdmission.payments[0].clientId === PaymentTypeClient.PRIVATE;
      const isHealthInsurance = !isPrivate;

      const switchPaymentType =
        (isPrivate && updateToHealthInsurance) || (isHealthInsurance && updateToPrivate);

      let updateAdmission;

      if (switchPaymentType) {
        updateAdmission = await this.updateAdmissionPaymentSwitchType(paymentPayload);
        await this.setAdmissionNotElegible();
      } else if (updateToPrivate) {
        updateAdmission = await this.updateAdmissionPaymentPrivate(paymentPayload);
      } else if (!updateAdmission) {
        updateAdmission = await this.updateAdmissionPaymentHealthInsurance(paymentPayload);
      }

      return updateAdmission;
    },
  },
};
